import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import { useDeleteTasks } from 'features/tasks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DialogVariantOptions } from 'shared/assets/styles';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';

import * as Styled from './dialogs.style';
import { DialogProps } from './types';

export const DeleteTasksDialog: React.FC<DialogProps> = ({
  tasks,
  onClose,
}) => {
  const { t } = useTranslation();
  const deleteTasks = useDeleteTasks();

  const onDelete = () => {
    deleteTasks(tasks, true);
    onClose();
  };

  return (
    <Dialog open onClose={onClose} variant={DialogVariantOptions.ExtraSmall}>
      <Styled.DialogHeader>
        <Typography variant="h5" component="h1">
          {t('context-menus.task.forms.delete-multiple.title')}
        </Typography>
      </Styled.DialogHeader>

      <Styled.DialogBody>
        <Typography variant="body2">
          {t('context-menus.task.forms.delete-multiple.body', {
            count: tasks.length,
          })}
        </Typography>
      </Styled.DialogBody>

      <Styled.DialogFooter>
        <Button
          variant={Variants.Contained}
          size={Sizes.Medium}
          color={Colors.White}
          onClick={onClose}
        >
          {t('context-menus.task.forms.delete-multiple.footer.cancel')}
        </Button>
        <Button size={Sizes.Medium} color={Colors.Error} onClick={onDelete}>
          {t('context-menus.task.forms.delete-multiple.footer.submit')}
        </Button>
      </Styled.DialogFooter>
    </Dialog>
  );
};
